import { render, staticRenderFns } from "./FirstGoalLastGoal.vue?vue&type=template&id=130f7cf6&"
import script from "./FirstGoalLastGoal.vue?vue&type=script&lang=js&"
export * from "./FirstGoalLastGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports